import { createActionGroup, props } from "@ngrx/store";
import { FinancingCompany } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataFinancingCompaniesActions = createActionGroup({
    source: "Data / Financing Companies",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ financingCompanies: FinancingCompany[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
